var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switchWrap"},[_c('div',{staticClass:"switch",on:{"click":_vm.toggle}},[_c('span',{staticClass:"circle main-second-bg",class:_vm.isChecked ? 'circleChecked' : 'circleCheckOut'}),_c('p',{staticClass:"boxStyle",class:_vm.isChecked ? 'switchBottomChecked blue-bg' : 'switchBottom gray-bg'})])])
}
var staticRenderFns = []

export { render, staticRenderFns }